export const formatTitle = (str) => {
  if (!str) return "";

  const formatted = str.replace(/-/g, " ");
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};
